"use client"
import React from "react"
import Navbar from "../../components/admin/common/Navbar"
import CampaignBuilder from "../../components/admin/marketing/CampaignBuilder"

const MarketingCampaignBuilder = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignBuilder />
      </main>
    </div>
  )
}

export default MarketingCampaignBuilder
